/**
 * Turn content into a file and start the download for the user
 * Borrowed from http://bit.ly/2oKP2ll
 */
const downloadFile = (filename: string, content: string) => {
  const el = document.createElement('a');
  const file = new File([content], filename, { type: 'application/json' });
  const href = URL.createObjectURL(file);

  el.setAttribute('href', href);
  el.setAttribute('download', filename);
  el.style.display = 'none';

  if (document.body !== null) {
    document.body.appendChild(el);
  }

  el.click();

  if (document.body !== null) {
    document.body.removeChild(el);
  }
};

export default downloadFile;
